import React, { useState, useEffect, createContext, useContext } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Banner from './components/Banner';
import Brand from './components/Brand';
import Stats from './components/Stats';
import Services from './components/Services';
import Philosophy from './components/Philosophy';
import Projects from './components/Projects';
import Journey from './components/Journey';
import Quote from './components/Quote';
import Team from './components/Team';
import Marquee from './components/Marquee';
import Footer from './components/Footer';
import ThemeToggle from './components/ThemeToggle';
import LanguageToggle from './components/LanguageToggle';
import { translations } from './translations';

export const LanguageContext = createContext();

function App() {
  const [isDark, setIsDark] = useState(false);
  const [isHindi, setIsHindi] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const savedLang = localStorage.getItem('language');
    if (savedTheme) setIsDark(savedTheme === 'dark');
    if (savedLang) setIsHindi(savedLang === 'hi');
  }, []);

  const toggleTheme = () => {
    const newTheme = !isDark;
    setIsDark(newTheme);
    localStorage.setItem('theme', newTheme ? 'dark' : 'light');
  };

  const toggleLanguage = () => {
    const newLang = !isHindi;
    setIsHindi(newLang);
    localStorage.setItem('language', newLang ? 'hi' : 'en');
  };

  const t = translations[isHindi ? 'hi' : 'en'];

  return (
    <LanguageContext.Provider value={t}>
      <div className={`App ${isDark ? 'dark' : 'light'}`}>
        <ThemeToggle isDark={isDark} toggleTheme={toggleTheme} />
        <LanguageToggle isHindi={isHindi} toggleLanguage={toggleLanguage} />
        <Navbar />
        <Banner />
        <Brand />
        <Stats />
        <Services />
        <Philosophy />
        <Projects />
        {/* <Journey /> */}
        <Quote />
        <Team />
        <Marquee />
        <Footer />
      </div>
    </LanguageContext.Provider>
  );
}

export const useTranslation = () => useContext(LanguageContext);

export default App;